import { useMutation } from '@tanstack/react-query';
import { confirmPaymentService, createPaymentService } from 'domains/payments/services/payment.service';
import { TConfirmPaymentParams, TCreatePaymentReqData } from 'domains/payments/types/payment.types';

export const useCreatePaymentMutation = (): any =>
  useMutation({
    mutationFn: (data: { params: TCreatePaymentReqData, counterpartyGUID: string }) =>
      createPaymentService(data.params, data.counterpartyGUID),
  });

export const useConfirmPaymentMutation = (): any =>
  useMutation({
    mutationFn: ({ data, senderCounterpartyGUID }: TConfirmPaymentParams) =>
      confirmPaymentService({ data, senderCounterpartyGUID }),
  });
